import React from 'react';
import { List } from 'immutable';

import { Paragraph } from '@uncinc/react-drupal-core';

import './style.scss';

const ParagraphCtaGroup = ({ entity }) => {
  return (
    <div className="CtaGroup">
      <div className="row no-gutters">
        {entity.get('field_cta_items') ? (
          entity.get('field_cta_items', List()).map((paragraph) => {
            const id = paragraph.get('target_id');
            const language = paragraph.getIn(['entity', 'langcode', 0, 'value']);
            return (
              <div className="col-12 col-md-4 CtaGroup__item" key={`paragraph:${id}:${language}`}>
                <Paragraph
                  id={id}
                  entity={paragraph.get('entity')}
                />
              </div>
            );
          })
        ) : null}
      </div>
    </div>
  );
};

export default ParagraphCtaGroup;
